(function () {
    const tocJs = {
        $loa: null,
        vPort: 'screen-xs',
        init: function () {
            const $toSection = $('.to-section');
            if ($toSection.length) {
                $toSection.each(function () {
                    var section = $(this).text();
                    var id = $(this).attr('id');
                    $('<li><a class="w-slide__hide" href="#' + id + '"><span>' + section + '</span></a></li>').appendTo(
                        '.sections__drop'
                    );
                });
            } else {
                $('.toc-go-section, .toc__section').remove();
            }
            tocJs.$loa = $('.issue-item .loa, .search__item .meta__authors, .search__item .loa');
            tocJs.control();
            tocJs.additionalControl();
        },
        control() {
            $(window).on('load orientationchange', function (event) {
                tocJs.truncate();
            });

            $(document).on(tocJs.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                tocJs.isMobile = true;
                tocJs.truncate();
            });

            $(document).on(tocJs.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                tocJs.isMobile = false;
                tocJs.truncate();
            });
        },
        additionalControl() {},
        truncate() {
            try {
                tocJs.$loa.not("[data-truncate='none']").truncate({
                    lines: 2,
                    type: 'list',
                    seeMoreLink: true,
                    seeMoreText: 'See all authors',
                    seeLessText: 'See fewer authors',
                });
            } catch (err) {
                console.error(err);
            }
        },
    };
    UX.tocJs = tocJs; // add to global namespace
})();
